import React from 'react';
import './Boost.css'; // Import CSS file for styling
import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed

function Instant() {
  return (
    <div className='back'>
      <div className='pad boost-container centered-text'>
        <span className='large-text3'>
          <TranslateText text="INSTANTANEOUSLY RAISE YOUR CREDIT SCORE WITH INQUIRY REMOVAL." />
        </span>

        <div className='push'></div>
        <span className='large-text2a'>
          <TranslateText text="10% of your score is determined based on your credit inquiries" />
        </span>
        <span className='large-text2a'>
          <TranslateText text="so if your number of inquiries is decreased, then bam!" />
        </span>
        <span className='large-text2a'>
          <TranslateText text="Your credit score will increase automatically." />
        </span>
        <span className='large-text2a'>
          <TranslateText text="We can remove up to 100 credit inquiries across all three credit bureaus." />
        </span>
        <span className='large-text2a'>
          <TranslateText text="Typical results are 15-30 days." />
        </span>
      </div>
    </div>
  );
}

export default Instant;



// import React from 'react'
// import './Boost.css'; // Import CSS file for styling
// function Instant() {
//   return (
//     <div className='back'>
//     <div className='pad boost-container centered-text'>
//         <span className='large-text3'>INSTANTANEOUSLY RAISE YOUR CREDIT SCORE WITH INQUIRY REMOVAL. </span>
       
//         <div className='push'></div>
//         <span className='large-text2a'>10% of your score is determined based on your credit inquiries   </span>
//         <span className='large-text2a'>so if your number of inquiries is decreased, then bam! </span>
//         <span className='large-text2a'>Your credit score will increase automatically.</span>
//         <span className='large-text2a'>We can remove up to 100 credit inquiries across all three credit bureaus.  </span>
//         <span className='large-text2a'>Typical results are 15-30 days.</span>




//          </div>  
//     </div>
//   )
// }

// export default Instant
